import ActionComponent from 'app/shared/components/common/action-component';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { Markup } from 'interweave';
import React from 'react';
import './style.scss';

const MobileNoMatchedAdhesion = props => {
  const { nextView, dataConf, accoutAssignementCms, avatar } = props;

  return (
    <div className="mobile-no-matched pad-msg-avatar">
      <AvatarWithBadge
        avatar={avatar}
        previousLink={'/contracts'}
        title=
        {[accoutAssignementCms?.no_mattched_subscription?.not_matched_sub_avatar_text]}
      />
      <br />
      <div className="scroll-y">
        <div className="contact-form">
          <div className="item-form">
            <div className="d-flex flex-row">
              <div className="mobile-tel-icon">
                <img src={accoutAssignementCms?.administrator_contact?.phone_icon} style={{ height: '15px', width: '15px' }} />
              </div>
              <div className="info-contact-style">
                <span className="label-contact-style">  <Markup content={accoutAssignementCms?.no_mattched_subscription?.phone_text} /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNoMatchedAdhesion;
